import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import ContactForm from "@/pages/contact/components/ContactForm";
import { SITE_URL, siteConfig } from "@/mocks/site";
import { buildBreadcrumbSchema } from "@/lib/seo";

const channels = [
  {
    icon: "ri-mail-send-line",
    title: "编辑部邮箱",
    desc: siteConfig.contactEmail,
    href: `mailto:${siteConfig.contactEmail}`,
    note: "推荐看点、内容纠错与一般咨询",
  },
  {
    icon: "ri-lightbulb-flash-line",
    title: "线索与投稿",
    desc: siteConfig.pressEmail,
    href: `mailto:${siteConfig.pressEmail}`,
    note: "请附上链接与一句说明，方便快速判断",
  },
  {
    icon: "ri-refresh-line",
    title: "更新节奏",
    desc: siteConfig.updatedAt,
    href: "",
    note: "早上发布清单，晚上补充当日新增热点",
  },
];

export default function Contact() {
  const jsonLd = [
    buildBreadcrumbSchema([
      { name: "首页", path: "/" },
      { name: "联系我们", path: "/contact" },
    ]),
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "联系我们",
      url: `${SITE_URL}/contact`,
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteConfig.name,
      url: `${SITE_URL}/`,
      email: siteConfig.contactEmail,
    },
  ];

  return (
    <>
      <Seo
        title="联系我们 - 黑料看点投稿、纠错与合作通道"
        description="想推荐看点、提供线索、反馈问题或洽谈合作？通过黑料看点联系页面留言，或直接发送邮件到编辑部，我们会尽快回复。"
        keywords="黑料看点联系方式,投稿,内容纠错,合作"
        path="/contact"
        jsonLd={jsonLd}
      />

      <section className="bg-background-50 border-b border-background-200">
        <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 pt-6 pb-8 md:pt-8 md:pb-10">
          <Breadcrumbs items={[{ name: "联系我们" }]} />
          <h1 className="mt-6 font-heading text-3xl md:text-4xl text-foreground-950">联系我们</h1>
          <p className="mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
            不管是想推荐一条好看的看点，还是发现内容有误想提醒我们，欢迎随时留言。每一条我们都会看完。
          </p>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-12 md:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
            <div className="lg:col-span-5 flex flex-col gap-5">
              {channels.map((item) => (
                <div key={item.title} className="flex gap-4 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 shrink-0">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <div className="min-w-0">
                    <h2 className="text-base font-semibold text-foreground-950">{item.title}</h2>
                    {item.href ? (
                      <a href={item.href} rel="nofollow" className="mt-1 block text-sm text-primary-700 hover:text-primary-600 break-all">
                        {item.desc}
                      </a>
                    ) : (
                      <p className="mt-1 text-sm text-foreground-800">{item.desc}</p>
                    )}
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">{item.note}</p>
                  </div>
                </div>
              ))}

              <div className="rounded-lg bg-secondary-100 border border-secondary-200 p-5 md:p-6">
                <h2 className="text-base font-semibold text-secondary-900">回复时效</h2>
                <p className="mt-2 text-sm leading-relaxed text-secondary-900/85">
                  一般情况下我们会在一个工作日内回复。涉及内容纠错的反馈会优先处理，并同步更新到对应的看点上。
                </p>
                <Link to="/faq" className="mt-4 inline-flex items-center gap-1.5 text-sm text-secondary-800 hover:gap-2.5 transition-all">
                  先看看常见问题 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-8">
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950">在线留言</h2>
                <p className="mt-2 mb-6 text-sm text-foreground-600">
                  填写下面的表单即可，我们收到后会尽快回复。带 <span className="text-primary-600">*</span> 的为必填项。
                </p>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}